import * as React from 'react';
export const IcCallOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.71 3.29a.999.999 0 00-1.42 0l-16 16a1 1 0 000 1.42.998.998 0 001.42 0L9 16.42c3.44 3.07 6.44 3.15 7.76 3a1.89 1.89 0 001.13-.57l1-1a2 2 0 000-2.83l-.71-.71a2 2 0 00-2.82 0l-.71.71a.997.997 0 01-1.095.219.998.998 0 01-.325-.22l-1.43-1.41 8.91-8.9a.998.998 0 000-1.42zM9 10.79a.999.999 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13 9.12 9.12 0 001.75 6.16L9 10.79z'
      fill='currentColor'
    />
  </svg>
);
